"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFdrMapDefaultCenter = exports.FdrMapDefaultCenterProvider = void 0;
const react_1 = __importDefault(require("react"));
const FdrMapDefaultCenterContext = react_1.default.createContext(undefined);
function FdrMapDefaultCenterProvider({ coordinates, children, }) {
    return (react_1.default.createElement(FdrMapDefaultCenterContext.Provider, { value: coordinates
            ? { lat: coordinates.latitude, lng: coordinates.longitude }
            : undefined }, children));
}
exports.FdrMapDefaultCenterProvider = FdrMapDefaultCenterProvider;
function useFdrMapDefaultCenter() {
    return react_1.default.useContext(FdrMapDefaultCenterContext);
}
exports.useFdrMapDefaultCenter = useFdrMapDefaultCenter;
//# sourceMappingURL=fdr-map-default-center.context.js.map